import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Link } from "react-router-dom";
import { Tabs, Tab, AppBar } from "@material-ui/core";
import ParentPartnerDasboardContainerGraph from "./parentPartnerDashboardContainerGraph.js";
import {
  ToastsContainer,
  ToastsStore,
  ToastsContainerPosition,
} from "react-toasts";
import { Auth } from "aws-amplify";  // Logging out
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Line,
  LineChart,
} from "recharts";

import * as envKeys from "../../ENV";

import {
  getAffiliateDashboardUserAction,
  getAffiliateDashboardUserForParent,
  getBarGraphDataForDashboard,
  getAffiliateUser,
  getSettlementListByAffiliateType,
  getAllGroupsByParentAffiliateUser,
  getBarGraphDataForDashboardWithSettlementIdForParentUser,
  getMonthlyEnrollmentsByAffiliateGroup,
  getBarGraphDataForDashboardWithSettlementIdForParentUserForGroup,
  logoutUser, clearDataEmail                   // Logging out (Both)
} from "../../Actions/actions";

const styles = {
  root: {
    flexGrow: 1,
  },
  flex: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  tabsRoot: {
    borderBottom: "4px solid #ef6262",
  },
  tabsIndicator: {
    backgroundColor: "#1890ff",
  },

  tabSelected: {},
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#000",
    },
  },
};

class parentPartnerDashboardContainer extends React.Component {
  state = {
    userId: localStorage.getItem("userId"),
    GetAffiliateUserData: {},
    isLoader: false,
    settlementId: null,
    groupId: null,
    chartDataGraph: [],
    lineChartDataGraph: [],
    chartDataGraph1: [],
    parentPartnerId: "",
    tabValue: 0,
    newValue: [],
  };

  componentDidMount() {
    const { userId } = this.state;
    const {
      getAffiliateDashboardUserAction,
      getAffiliateUser,
      getAffiliateDashboardUserForParent,
    } = this.props;
    getAffiliateDashboardUserAction({ userId });
    getAffiliateDashboardUserForParent({ userId });
    getAffiliateUser(userId);
    this.fetchBarGraph();
    this.fetchBarGraphForGroup();
    // this.fetchLineGraph();
  }

  fetchData = () => {
    const { affiliateType, userId, parentPartnerId } = this.state;
    const { getSettlementListByAffiliateType } = this.props;
    getSettlementListByAffiliateType({
      affiliateType: "both",
      userId,
      pageNumber: 1,
      pageSize: 30000,
      searchKeyword: "",
      sortBy: "",
    });
    this.props.getAllGroupsByParentAffiliateUser({
      pageNumber: 1,
      pageSize: 30000,
      searchKeyword: "",
      affiliateType: "both",
      parentPartnerId: this.props.data.GetAffiliateUser.affiliateUserId,
      displayMode: "partner",
    });
    if (this.props.data.GetAffiliateUser.affiliateUserId) {
      this.fetchLineGraph(this.props.data.GetAffiliateUser.affiliateUserId);
    }
  };

  fetchBarGraph = () => {
    const { userId, settlementId } = this.state;
    const {
      getBarGraphDataForDashboardWithSettlementIdForParentUser,
    } = this.props;

    getBarGraphDataForDashboardWithSettlementIdForParentUser({
      userId,
      settlementId: !settlementId || settlementId == "" ? null : settlementId,
    });
  };

  fetchLineGraph = (data) => {
    const { parentPartnerId, settlementId } = this.state;
    const { getMonthlyEnrollmentsByAffiliateGroup } = this.props;

    getMonthlyEnrollmentsByAffiliateGroup({
      parentPartnerId: data,
      settlementId: !settlementId || settlementId == "" ? null : settlementId,
    });
  };

  fetchBarGraphForGroup = () => {
    const { userId, settlementId, groupId } = this.state;
    const {
      getBarGraphDataForDashboardWithSettlementIdForParentUserForGroup,
    } = this.props;

    getBarGraphDataForDashboardWithSettlementIdForParentUserForGroup({
      userId,
      settlementId: null,
      groupId: !groupId || groupId == "" ? null : groupId,
    });
  };

  componentDidUpdate() {
    const {
      GetAffiliateUser,
      parentBarGraphData,
      parentLineGraphData,
      receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer,
    } = this.props.data;
    const {
      GetAffiliateUserData,
      barGraphData1,
      barGraphData2,
      lineGraphData,
    } = this.state;
    if (GetAffiliateUserData !== GetAffiliateUser) {
      // if (GetAffiliateUser && GetAffiliateUser.affiliateType !== undefined) {
      this.setState(
        {
          // affiliateType: GetAffiliateUser.affiliateType,
          GetAffiliateUserData: GetAffiliateUser,
        },
        () => {
          // if (GetAffiliateUser.affiliateType && GetAffiliateUser.affiliateType !== "") {
          this.fetchData();
          // }
        }
      );
      // }
    }

    if (
      receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer &&
      receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer.status !==
        "NOT_FOUND"
    ) {
      if (
        barGraphData2 !==
        receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer
      ) {
        if (
          receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer.barGraphDtos !==
          undefined
        ) {
          const dataBarGraph = [];

          receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer &&
            receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer.barGraphDtos.map(
              (barGraphDtos) => {
                dataBarGraph.push({
                  name: barGraphDtos.monthLabel,
                  Users: barGraphDtos.users,
                  Enrollments: barGraphDtos.enrollments,
                });
                return true;
              }
            );
          this.setState({
            chartDataGraph1: dataBarGraph,
            barGraphData2: receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer,
          });
        }
      }
    }

    if (parentBarGraphData && parentBarGraphData.status !== "NOT_FOUND") {
      if (barGraphData1 !== parentBarGraphData) {
        if (parentBarGraphData.barGraphDtos !== undefined) {
          const dataBarGraph = [];

          parentBarGraphData &&
            parentBarGraphData.barGraphDtos.map((barGraphDtos) => {
              dataBarGraph.push({
                name: barGraphDtos.monthLabel,
                Users: barGraphDtos.users,
                Enrollments: barGraphDtos.enrollments,
              });
              return true;
            });

          // for (
          //   let index = 0;
          //   index <= parentBarGraphData.dataSetDtos[1].data.length;
          //   index++
          // ) {
          //   dataBarGraph.push({
          //     name: parentBarGraphData.labels[index],
          //     Users: parentBarGraphData.dataSetDtos[0].data[index],
          //     Enrollments: parentBarGraphData.dataSetDtos[1].data[index]
          //   });
          // }
          this.setState({
            chartDataGraph: dataBarGraph,
            barGraphData1: parentBarGraphData,
            // settlementUserIdAffiliateData2:settlementUserIdAffiliateData1.userDto
          });
        }
      }
    }

    if (parentLineGraphData && parentLineGraphData.status !== "NOT_FOUND") {
      if (lineGraphData !== parentLineGraphData) {
        if (parentLineGraphData.records !== undefined) {
          const dataLineGraph = [];

          parentLineGraphData &&
            parentLineGraphData.records.map((barGraphDtos) => {
              dataLineGraph.push({
                monthLabel: barGraphDtos.monthLabels,
                name: barGraphDtos.name,
                enrollments: barGraphDtos.enrollments,
              });
              return true;
            });

          this.setState({
            lineChartDataGraph: dataLineGraph,
            lineGraphData: parentLineGraphData,
            // settlementUserIdAffiliateData2:settlementUserIdAffiliateData1.userDto
          });
        }
      }
    }
  }

  tabChangeHandler = (e, val) => {
    this.setState({ tabValue: val });
  };

  handleSession = async () => {                   // Logging out
    await localStorage.clear();
    Auth.signOut().then(async () => {
      await this.props.logoutUser();
      this.props.clearDataEmail();
      this.props.history.push("/");
    });
  }

  render() {
    if(typeof this.props.data.GetAffiliateUser === "undefined"){		 //For  Logging out
      this.handleSession();	                                         //
    }                                                                //
    const {
      data: {
        affiliateDashboardDataForparent,
        settlementDataAffiliate,
        parentBarGraphData,
        parentLineGraphData,
        profileName,
        affiliateDashboardDataForparentForparent,
      },
    } = this.props;
    const {
      chartDataGraph,
      lineChartDataGraph,
      settlementId,
      groupId,
      chartDataGraph1,
    } = this.state;
    const {
      data: {
        receiveAllGroupsByParentAffiliateUser,
        receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer,
      },
    } = this.props;
    return (
      <div className="p-overview prt-dashboard">
        <div className="p-overview-heading">
          <h3 className="p-h3">
            Welcome{" "}
            <span className="p-sub-h3">{profileName && profileName}</span>
          </h3>
          <h4 className="p-h4">Performance</h4>
        </div>
        <div className="p-overview-scorecard">
          {this.state.GetAffiliateUserData && this.state.GetAffiliateUserData.affiliateType != "Consumer" ? (           // Logging out
            <div className="p-card p-card-blue monthly-score">
              <h2>
                $
                {affiliateDashboardDataForparent &&
                affiliateDashboardDataForparent.partnerMMR &&
                affiliateDashboardDataForparent.partnerMMR.partnerMMR
                  ? affiliateDashboardDataForparent.partnerMMR.partnerMMR.toFixed(
                      2
                    )
                  : 0}
              </h2>
              <p>Monthly Recuring Revenue</p>
              <label>*Includes annual subscriptions</label>
              <div className="line-divider"></div>
              <h2>
                $
                {this.props.data.parentBarGraphData &&
                  this.props.data.parentBarGraphData.totalRecovery &&
                  this.props.data.parentBarGraphData.totalRecovery.toFixed(2)}
              </h2>
              <p>Total Recovery</p>
            </div>
          ) : (
            ""
          )}

          <div className="p-card  full-score p-d-flex">
            <div className="p-performance-users p-border-right">
              <h3 className="p-h3 p-font-bold">
                {affiliateDashboardDataForparent &&
                  affiliateDashboardDataForparent.otherValuesMap &&
                  affiliateDashboardDataForparent.otherValuesMap
                    .Total_Refered_Users}
              </h3>
              <label className="text-uppercase p-font-bold">Total Users</label>
              <div className="p-cost-list p-plan-users-cost">
                <div className="p-cost-item">
                  <h4 className="p-h4 p-font-medium">
                    {affiliateDashboardDataForparent &&
                    affiliateDashboardDataForparent.finalMap &&
                    affiliateDashboardDataForparent.finalMap.planMap &&
                    affiliateDashboardDataForparent.finalMap.planMap.Basic
                      ? affiliateDashboardDataForparent.finalMap.planMap.Basic
                      : 0}
                  </h4>
                  <label className="text-uppercase p-font-bold">Basic</label>
                </div>
                <div className="p-cost-item">
                  <h4 className="p-h4 p-font-medium">
                    {affiliateDashboardDataForparent &&
                    affiliateDashboardDataForparent.finalMap &&
                    affiliateDashboardDataForparent.finalMap.planMap &&
                    affiliateDashboardDataForparent.finalMap.planMap.Flex
                      ? affiliateDashboardDataForparent.finalMap.planMap.Flex
                      : 0}
                  </h4>
                  <label className="text-uppercase p-font-bold">Flex</label>
                </div>
                <div className="p-cost-item">
                  <h4 className="p-h4 p-font-medium">
                    {affiliateDashboardDataForparent &&
                    affiliateDashboardDataForparent.finalMap &&
                    affiliateDashboardDataForparent.finalMap.planMap &&
                    affiliateDashboardDataForparent.finalMap.planMap.Premium
                      ? affiliateDashboardDataForparent.finalMap.planMap.Premium
                      : 0}
                  </h4>
                  <label className="text-uppercase p-font-bold">Premium</label>
                </div>
              </div>
            </div>
            <div className="p-performance-users p-left">
              <h3 className="p-h3 p-font-bold">
                {affiliateDashboardDataForparent &&
                  affiliateDashboardDataForparent.otherValuesMap &&
                  affiliateDashboardDataForparent.otherValuesMap
                    .Total_Enroll_Settlements}
              </h3>
              <label className="text-uppercase p-font-bold">
                Total Enrollments
              </label>
              <div className="p-cost-list">
                <div className="p-cost-item">
                  <h4 className="p-h4 p-font-bold">
                    {affiliateDashboardDataForparent &&
                    affiliateDashboardDataForparent.otherValuesMap &&
                    isNaN(
                      affiliateDashboardDataForparent.otherValuesMap
                        .Total_Enroll_Settlements /
                        affiliateDashboardDataForparent.otherValuesMap
                          .Total_Refered_Users
                    ) === false
                      ? (
                          affiliateDashboardDataForparent.otherValuesMap
                            .Total_Enroll_Settlements /
                          affiliateDashboardDataForparent.otherValuesMap
                            .Total_Refered_Users
                        ).toFixed(2)
                      : 0}
                  </h4>
                  <label className="text-uppercase p-font-bold">
                    Avg. Enrollments per user
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-overview-Settlements">
          <div className="table-filter">
            <h3 className="table-filter-tittle">
              Settlements{" "}
              <span>
                {settlementDataAffiliate && settlementDataAffiliate.result && (
                  <span>({settlementDataAffiliate.result.totalCount})</span>
                )}
              </span>
            </h3>
          </div>
          <div className="p-overview-Settlements-card p-card graph-tab">
            {this.state.tabValue === 0 ? (
              <div className="p-overview-Settlements-left">
                <div className="p-select">
                  <select
                    className="p-ro-select"
                    name="settlementId"
                    placeholder="Select an settlements"
                    value={settlementId}
                    onChange={(event) => {
                      this.setState(
                        {
                          settlementId: event.target.value,
                        },
                        () => {
                          this.fetchBarGraph();
                        }
                      );
                    }}
                  >
                    <option className="p-option-style" value="">
                      All Settlements
                    </option>
                    {settlementDataAffiliate &&
                      settlementDataAffiliate.result &&
                      settlementDataAffiliate.result.totalSettlementForDropdown.map(
                        (categoryList, index) => (
                          <option
                            className="p-option-style"
                            key={index}
                            value={categoryList.settlementId}
                          >
                            {categoryList.shortName}
                          </option>
                        )
                      )}
                  </select>
                </div>
                <div className="p-cost-list">
                  <div className="p-cost-item">
                    <h4 className="p-h4 p-font-bold">
                      {settlementId === null || settlementId === ""
                        ? affiliateDashboardDataForparent &&
                          affiliateDashboardDataForparent.otherValuesMap &&
                          affiliateDashboardDataForparent.otherValuesMap
                            .Total_Enroll_Settlements
                        : parentBarGraphData &&
                          parentBarGraphData.totalEnrollments
                        ? parentBarGraphData.totalEnrollments
                        : 0}
                    </h4>
                    <label className="text-uppercase p-font-medium">
                      Enrollments
                    </label>
                  </div>
                  {/* {(settlementId !== null && settlementId !== "") && <div className="p-cost-item">
                  <h4 className="p-h4 p-font-bold">${parentBarGraphData && parentBarGraphData.partnerMMR}</h4>
                  <label className="text-uppercase p-font-medium">MRR</label>
                </div>} */}
                </div>
                {settlementId !== null && settlementId !== "" && (
                  <div className="p-cost-item">
                    <Link
                      to={`/settlementAffiliate/enrollment-list/${settlementId}`}
                      className=" view-settlement-link p-font-medium"
                    >
                      View Settlement
                    </Link>
                  </div>
                )}
              </div>
            ) : (
              <div className="p-overview-Settlements-left p-item-warp">
                <div className="p-select">
                  <select
                    className="p-ro-select"
                    name="settlementId"
                    placeholder="Select an settlements"
                    value={settlementId}
                    onChange={(event) => {
                      this.setState(
                        {
                          settlementId: event.target.value,
                        },
                        () => {
                          this.fetchLineGraph(
                            this.props.data.GetAffiliateUser.affiliateUserId
                          );
                        }
                      );
                    }}
                  >
                    <option className="p-option-style" value="">
                      All Settlements
                    </option>
                    {settlementDataAffiliate &&
                      settlementDataAffiliate.result &&
                      settlementDataAffiliate.result.totalSettlementForDropdown.map(
                        (categoryList, index) => (
                          <option
                            className="p-option-style"
                            key={index}
                            value={categoryList.settlementId}
                          >
                            {categoryList.shortName}
                          </option>
                        )
                      )}
                  </select>
                </div>
                <div className="p-cost-list">
                  <div className="p-cost-item">
                    <h4 className="p-h4 p-font-bold">
                      {settlementId === null || settlementId === ""
                        ? affiliateDashboardDataForparent &&
                          affiliateDashboardDataForparent.otherValuesMap &&
                          affiliateDashboardDataForparent.otherValuesMap
                            .Total_Enroll_Settlements
                        : parentLineGraphData && parentLineGraphData.totalCount
                        ? parentLineGraphData.totalCount
                        : 0}
                    </h4>
                    <label className="text-uppercase p-font-medium">
                      Enrollments
                    </label>
                  </div>
                  {/* {(settlementId !== null && settlementId !== "") && <div className="p-cost-item">
                 <h4 className="p-h4 p-font-bold">${parentBarGraphData && parentBarGraphData.partnerMMR}</h4>
                 <label className="text-uppercase p-font-medium">MRR</label>
               </div>} */}
                  {/* {
              //  (settlementId === null && settlementId !== "") &&      --- singleline has changed earlier
               <div className="p-cost-item">
                 <h4 className="p-h4 p-font-bold">$209</h4>
                 <label className="text-uppercase p-font-medium">MRR</label>
               </div>}  */}
                  {/* {
              //  (settlementId === null && settlementId !== "") &&     --- singleline has changed earlier
               <div className="p-cost-item">
                 <h4 className="p-h4 p-font-bold">18</h4>
                 <label className="text-uppercase p-font-medium">MONTHS ACTIVE</label>
               </div>}  */}
                </div>
                <div className="p-cost-list copy-link">
                  {/* {settlementId === null && settlementId !== "" && ( */}
                  {
                    //  <div className="p-cost-item">
                    //    <Link
                    //      to="#"
                    //      className=" view-settlement-link p-font-medium"
                    //    >
                    //      Copy URL
                    //    </Link>
                    //  </div>
                    //  )
                  }
                  {
                    //  settlementId === null && settlementId !== "" && (
                    //  <div className="p-cost-item">
                    //    <Link
                    //      to="#"
                    //      className=" view-settlement-link p-font-medium"
                    //    >
                    //      View
                    //    </Link>
                    //  </div>
                    //  )
                  }
                </div>
              </div>
            )}

            <div
              className={
                parentBarGraphData && parentBarGraphData.length === 0
                  ? "p-overview-Settlements-right no-record-graph"
                  : "p-overview-Settlements-right"
              }
            >
              <AppBar position="static">
                <Tabs
                  value={this.state.tabValue}
                  onChange={this.tabChangeHandler}
                >
                  <Tab label="Users + Enrollments"></Tab>
                  <Tab label="Groups"></Tab>
                </Tabs>
              </AppBar>
              <TabPanel value={this.state.tabValue} index={0}>
                {parentBarGraphData && parentBarGraphData.length === 0 ? (
                  <div className="noData">No Data</div>
                ) : chartDataGraph && chartDataGraph.length === 0 ? (
                  <div className="noData">No Data</div>
                ) : (
                  <div className="settlement-graph-overview">
                    <div className="graph-heading">Users + Enrollments</div>
                    <BarChart width={700} height={200} data={chartDataGraph}>
                      <CartesianGrid vertical={false} />

                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Legend iconType="circle" />
                      <Bar
                        maxBarSize={8}
                        dataKey="Users"
                        fill="#19d490"
                        radius={20}
                      />
                      <Bar
                        maxBarSize={8}
                        dataKey="Enrollments"
                        fill="#e220b2"
                        radius={20}
                      />
                    </BarChart>
                  </div>
                )}
              </TabPanel>
              <TabPanel value={this.state.tabValue} index={1}>
                {parentLineGraphData && parentLineGraphData.length === 0 ? (
                  <div className="noData">No Data</div>
                ) : (lineChartDataGraph && lineChartDataGraph.length === 0 || (lineChartDataGraph.length>0 && lineChartDataGraph.every(x=>x["enrollments"]===undefined))) ? (
                  <div className="noData" >No Data</div>
                ) : (
                  <div className="settlement-graph-overview">
                    <div className="graph-heading">Users + Enrollments</div>
                    {/* <BarChart width={700} height={200} data={chartDataGraph}>
                    <CartesianGrid vertical={false} />

                    <XAxis dataKey="name" />
                    <YAxis   domain = {[0,225]} tickCount="10"/>
                    <Tooltip />
                    <Legend iconType="circle" />
                    <Bar
                      maxBarSize={8}
                      dataKey="Users"
                      fill="#19d490"
                      radius={20}
                    />
                    <Bar
                      maxBarSize={8}
                      dataKey="Enrollments"
                      fill="#e220b2"
                      radius={20}
                    />
                  </BarChart> */}

                    {/* <LineChart width={700} height={200} data={dataForGraph}>
                  <XAxis dataKey="monthLabel" type="category" allowDuplicatedCategory={false}/>
                  <YAxis dataKey="enrollments"/>
                  <Tooltip/>
                  <CartesianGrid vertical={false} />
                  
                  <CartesianGrid stroke="#eee" strokeDasharray="5 5"/>
                  {lineChartDataGraph && lineChartDataGraph.length > 0 && lineChartDataGraph[0].enrollments ? lineChartDataGraph.map(s=> { 
                    return (
                    s.enrollments.map(m=> 
                        return <Line  dataKey={m} data={m}  name={s.name} key={s.name} stroke="#8884d8" dot={false} />
                      }
                          
                      )
                      )
                  }
                  ) : "No data available"
                  }
                </LineChart> */}
                    {/* <LineChart width={700} height={200} data={lineChartDataGraph}>
                        <CartesianGrid vertical={false} />
                        <XAxis type="number" />
                        <YAxis dataKey="name" type="category" />
                        <Tooltip />
                        <Legend />
                        <Line dataKey="pv" stroke="#8884d8" />
                        <Line dataKey="uv" stroke="#82ca9d" />
                </LineChart> */}
                    <ParentPartnerDasboardContainerGraph
                      rawData={lineChartDataGraph}
                    />
                  </div>
                )}
              </TabPanel>
            </div>
          </div>
        </div>

        <div className="p-overview-Settlements">
          <div className="table-filter">
            <h3 className="table-filter-tittle">
              Groups{" "}
              <span>
                {receiveAllGroupsByParentAffiliateUser &&
                  receiveAllGroupsByParentAffiliateUser.result && (
                    <span>
                      ({receiveAllGroupsByParentAffiliateUser.result.totalCount}
                      )
                    </span>
                  )}
              </span>
            </h3>
          </div>
          <div className="p-overview-Settlements-card p-card graph-tab ">
            <div className="p-overview-Settlements-left">
              <div className="p-select">
                <select
                  className="p-ro-select"
                  name="settlementId"
                  placeholder="Select an settlements"
                  value={groupId}
                  onChange={(event) => {
                    this.setState(
                      {
                        groupId: event.target.value,
                      },
                      () => {
                        this.fetchBarGraphForGroup();
                      }
                    );
                  }}
                >
                  <option className="p-option-style" value="">
                    All Groups
                  </option>
                  {receiveAllGroupsByParentAffiliateUser &&
                    receiveAllGroupsByParentAffiliateUser.result &&
                    receiveAllGroupsByParentAffiliateUser.result.records.map(
                      (categoryList, index) => (
                        <option
                          className="p-option-style"
                          key={index}
                          value={categoryList.id}
                        >
                          {categoryList.name}
                        </option>
                      )
                    )}
                </select>
              </div>
              <div className="p-cost-list p-cost-list-row">
                <div className="p-cost-item">
                  <h4 className="p-h4 p-font-bold">
                    {/* {groupId === null || groupId === ""
                      ? receiveAllGroupsByParentAffiliateUser &&
                      receiveAllGroupsByParentAffiliateUser.otherValuesMap &&
                      receiveAllGroupsByParentAffiliateUser.otherValuesMap
                          .Total_Enroll_Settlements
                      : parentBarGraphData &&
                        parentBarGraphData.totalEnrollments
                      ? parentBarGraphData.totalEnrollments
                      : 0} */}
                    {receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer &&
                      receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer.totalUsers}
                  </h4>
                  <label className="text-uppercase p-font-medium">Users</label>
                </div>
                <div className="p-cost-item">
                  <h4 className="p-h4 p-font-bold">
                    {/* {groupId === null || groupId === ""
                      ? receiveAllGroupsByParentAffiliateUser &&
                      receiveAllGroupsByParentAffiliateUser.otherValuesMap &&
                      receiveAllGroupsByParentAffiliateUser.otherValuesMap
                          .Total_Enroll_Settlements
                      : parentBarGraphData &&
                        parentBarGraphData.totalEnrollments
                      ? parentBarGraphData.totalEnrollments
                      : 0} */}
                    {receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer &&
                      receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer.totalEnrollments}
                  </h4>
                  <label className="text-uppercase p-font-medium">
                    Enrollments
                  </label>
                </div>
                <div className="p-cost-item">
                  <h4 className="p-h4 p-font-bold">{0}</h4>
                  <label className="text-uppercase p-font-medium">
                    Sub Groups
                  </label>
                </div>
                {/* <div className="p-cost-item">
                  <h4 className="p-h4 p-font-bold">{(settlementId === null || settlementId === "") ? affiliateDashboardDataForparent && affiliateDashboardDataForparent.otherValuesMap && affiliateDashboardDataForparent.otherValuesMap.Total_Enroll_Settlements : parentBarGraphData && parentBarGraphData.totalEnrollments ? parentBarGraphData.totalEnrollments : 0}</h4>
                  <label className="text-uppercase p-font-medium">Enrollments</label>
                </div> */}
                {/* {(settlementId !== null && settlementId !== "") && <div className="p-cost-item">
                  <h4 className="p-h4 p-font-bold">${parentBarGraphData && parentBarGraphData.partnerMMR}</h4>
                  <label className="text-uppercase p-font-medium">MRR</label>
                </div>} */}
              </div>
              {settlementId !== null && settlementId !== "" && (
                <div className="p-cost-item">
                  <Link
                    to={`/settlementAffiliate/enrollment-list/${settlementId}`}
                    className=" view-settlement-link p-font-medium"
                  >
                    View Settlement
                  </Link>
                </div>
              )}
            </div>
            <div
              className={
                parentBarGraphData && parentBarGraphData.length === 0
                  ? "p-overview-Settlements-right no-record-graph"
                  : "p-overview-Settlements-right"
              }
            >
              <AppBar position="static">
                <Tabs value={0}>
                  <Tab label="Users + Enrollments"></Tab>
                  <Tab label=""></Tab>
                </Tabs>
              </AppBar>
              {receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer &&
              receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer.length ===
                0 ? (
                <div className="noData">No Data</div>
              ) : chartDataGraph1 && chartDataGraph1.length === 0 ? (
                <div className="noData">No Data</div>
              ) : (
                <div className="settlement-graph-overview">
                  <div className="graph-heading">Users + Enrollments</div>
                  <BarChart width={700} height={200} data={chartDataGraph1}>
                    <CartesianGrid vertical={false} />

                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend iconType="circle" />
                    <Bar
                      maxBarSize={8}
                      dataKey="Users"
                      fill="#19d490"
                      radius={20}
                    />
                    <Bar
                      maxBarSize={8}
                      dataKey="Enrollments"
                      fill="#e220b2"
                      radius={20}
                    />
                  </BarChart>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="p-overview-partner-url-outer">
          <div className="table-filter">
            <h3 className="table-filter-tittle">
              Partner URLs{" "}
              <span>
                {affiliateDashboardDataForparent &&
                  affiliateDashboardDataForparent.affiliateLinkDtoList &&
                  `(${affiliateDashboardDataForparent.affiliateLinkDtoList.length})`}
              </span>
            </h3>
          </div>
          <div>
            <h5 className="p-head5">Link title</h5>
            <h5 className="p-head5">Link Status</h5>
          </div>
          {affiliateDashboardDataForparent &&
          affiliateDashboardDataForparent.affiliateLinkDtoList ? (
            <div className="p-overview-partner-url bgWhite">
              {affiliateDashboardDataForparent &&
                affiliateDashboardDataForparent.affiliateLinkDtoList &&
                affiliateDashboardDataForparent.affiliateLinkDtoList.map(
                  (item1, index) => (
                    <div key={index} className="p-overview-urls">
                      <div className="p-overview-urls-data p-d-flex">
                        {item1.identifierName ? (
                          <span className="topBlock">
                            {item1.identifierName}
                          </span>
                        ) : (
                          <span className="p-blue-link">
                            {" "}
                            {envKeys.REACT_APP_FRONTEND_URL}/signup/
                            {item1.affiliateKey}{" "}
                          </span>
                        )}

                        {item1.isActive === 0 ? (
                          <p className="p-head5 marginBlock">Disabled</p>
                        ) : (
                          <p className="p-head5 marginBlock">Enabled</p>
                        )}
                        <CopyToClipboard
                          className="p-black-btn"
                          text={`${envKeys.REACT_APP_FRONTEND_URL}/signup/${item1.affiliateKey}`}
                          onCopy={() =>
                            ToastsStore.info(
                              "Link copied!",
                              5000,
                              "toast-error-msg"
                            )
                          }
                        >
                          <a className="p-black-btn">Copy Link</a>
                        </CopyToClipboard>
                        <ToastsContainer
                          className="toast-error-msg"
                          position={ToastsContainerPosition.TOP_CENTER}
                          lightBackground
                          store={ToastsStore}
                        />

                        <label>{item1.affiliateLinkeSize} users</label>
                      </div>
                    </div>
                  )
                )}
              {affiliateDashboardDataForparent &&
              affiliateDashboardDataForparent.affiliateLinkDtoList.length === 0
                ? "No Partner URLs yet"
                : ""}
            </div>
          ) : (
            <p style={{ backgroundColor: "white" }}>No Partner URLs yet</p>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.data,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAffiliateDashboardUserAction,
      getAffiliateDashboardUserForParent,
      getBarGraphDataForDashboard,
      getAffiliateUser,
      getSettlementListByAffiliateType,
      getAllGroupsByParentAffiliateUser,
      getBarGraphDataForDashboardWithSettlementIdForParentUser,
      getMonthlyEnrollmentsByAffiliateGroup,
      getBarGraphDataForDashboardWithSettlementIdForParentUserForGroup,
      logoutUser, clearDataEmail                      //Logging out
    },
    dispatch
  );
export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(parentPartnerDashboardContainer)
);

function TabPanel(props) {
  const { children, value, index } = props;
  return value === index && <div>{children}</div>;
}
